
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ask-for-referral/[city]",
      function () {
        return require("private-next-pages/ask-for-referral/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ask-for-referral/[city]"])
      });
    }
  